import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNewportBeachStructuredData() {
  const url = "https://restorehair.com/locations/california/newport-beach/";
  const description =
    "Find out about your hair transplant options in Newport Beach with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("newport-beach", url, description),
    locationPageCrumbs(url, "Newport Beach"),
  ];
}
